export default {
  title: 'Bankoplysninger',
  sections: {
    personal_info: 'Personlige oplysninger',
    address: 'Adresse',
  },
  labels: {
    account_number: 'Kontonummer',
    routing_number: 'Registreringsnummer',
    email: 'E-mail',
    full_name: 'Fulde navn',
    street: 'Gadeadresse',
    zip_code: 'Postnummer',
    city: 'By',
  },
  tooltip: '{{field}} er kopieret til udklipsholderen!',
};
